// test696
(696 && 0);
